






















































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import { PluginDef } from '@fullcalendar/core';
import RequestsService from '@/mixins/requests.service';
import UsersService from '@/mixins/users.service';
import FiltersService from '@/mixins/filters.service';
import CurrentUserService from '@/mixins/currentUser.service';
import { Request, RequestId, LeaveTypeId } from '@/types/request';
import { EventFilters } from '@/components/_common/';
import { User, UserId } from '@/types/user';

declare type LeaveValue = 'remote' | 'sick' | 'paid' | 'demand';

@Component({
  components: {
    FullCalendar,
    EventFilters,
  },
  mixins: [ RequestsService, UsersService, FiltersService, CurrentUserService  ],
})
export default class EventCalendar extends Mixins(RequestsService, UsersService, FiltersService) {
  private calendarPlugins: PluginDef[] = [ dayGridPlugin ];
  private showTooltip: boolean = true;

  private calendarApi = null;
  private element = null;
  private mouse = {
    x: 100,
    y: 100,
  };

  get mouseAdjusted() {
    const windowSize = {
      width: window.innerWidth,
      height: window.innerWidth,
    };

    const maxMouse = {
      x: this.mouse.x + 100,
      y: this.mouse.y + 100,
    };

    const offsetX = maxMouse.x - windowSize.width;
    const offsetY = maxMouse.y - windowSize.height;

    return {
      x: (offsetX > -300) ? (this.mouse.x - 500 - offsetX) :  (this.mouse.x - 220),
      y: (this.mouse.y - 250),
    };
  }

  private setMouse(e: any): any {
    const coords = {
      x: e.pageX,
      y: e.pageY,
    };
    this.mouse = coords;
  }

  private eventMouseEnter(e: any): void {
    this.element = e;
    this.showTooltip = true;
  }

  private eventMouseLeave(e: any): void {
    this.element = null;
    this.showTooltip = false;
  }

  private eventClick(e: any): Promise<any> {
    const request = this.findRequest(e.event.id);
    return this.$store.dispatch('addEditRequest/showModal', request);
  }

  private findRequest(requestId: string): Request {
    const id = parseInt(requestId, 10);
    const requestObject = this.requests.find((request: Request) => request.id === id);
    return requestObject;
  }


  get calendarEvents() {
    return this.applyRequestFilters(this.requests)
    .map((request: Request) => ({
      id: request.id,
      start: request.dateStart,
      end: request.dateEnd,
      backgroundColor: this.getEventColors(request.leaveTypeId).background,
      textColor: this.getEventColors(request.leaveTypeId).foreground,
      title: `${this.getUser(request.userId!)} - ${this.getType(request.leaveTypeId)} (${this.getStatus(request.statusId)})`,
    }));
  }

  private getEventColors(leaveTypeId: number): { background: string, foreground: string } {
    const typeObject = this.leaveTypes.find((type: any) => type.id === leaveTypeId);
    if (!typeObject) { return { background: '#fff', foreground: '#000' }; }
    return {
      background: typeObject.colorBg,
      foreground: typeObject.colorFg,
    };
  }

  private created(): void {
    const cal = (this.$refs.fullCalendar as any);
    this.calendarApi = cal ? cal.getApi() : null;
    this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: false });
    this.$store.dispatch('requestStatuses/update', { force: false });
    this.$store.dispatch('requests/updateRequests');
    this.$store.dispatch('userRoles/update');
    this.$store.dispatch('users/updateUsers', { force: false });
  }
}
